import React, { useState } from "react";
import { OrgUser } from "./types";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (crewIds: string[]) => void;
  users: OrgUser[];
  initialCrewIds?: string[];
}

// Crew-only assignment modal. Forked from SMRTCOPAssignCrewModal; the
// previous Site Manager picker has been removed (notifications no
// longer route through a designated manager — the demo notification
// is self-targeted to the logged-in user).
export default function SiteCheckAssignCrewModal({
  isOpen,
  onClose,
  onSubmit,
  users,
  initialCrewIds = [],
}: Props) {
  const [crew, setCrew] = useState<string[]>(initialCrewIds);

  if (!isOpen) return null;

  const toggleCrew = (id: string) => {
    setCrew((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  return (
    <div className="sc-modal-overlay">
      <div className="sc-modal" style={{ width: 520 }}>
        <div className="sc-modal-header">
          <h2>Assign Crew</h2>
          <button className="sc-btn-cancel" onClick={onClose}>Close</button>
        </div>

        <div className="sc-modal-body">
          <div className="sc-field">
            <span>Crew (can complete the wizard)</span>
            <div className="sc-crew-list">
              {users.length === 0 && (
                <p className="sc-empty">No users in this org yet.</p>
              )}
              {users.map((u) => (
                <label key={u.id} className="sc-crew-row">
                  <input
                    type="checkbox"
                    checked={crew.includes(u.id)}
                    onChange={() => toggleCrew(u.id)}
                  />
                  <span>{u.name}</span>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="sc-modal-footer">
          <button className="sc-btn-primary" onClick={() => onSubmit(crew)}>Assign</button>
        </div>
      </div>
    </div>
  );
}
